import React from 'react'

import { faGearComplexCode, faKey } from '@fortawesome/pro-regular-svg-icons'

export const getAdminViewSidebarItems = ({ history, isMFAEnabled }) => [
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>dashboard</span>,
    label: 'dashboard',
    selected: true,
    variant: 'primary',
    onClick() {
      history.push('/admin/dashboard')
    },
    _meta: {
      itemActiveRoutes: '/admin/dashboard'
    }
  },
  {
    itemType: 'section',
    label: 'directory'
  },
  {
    icon: faKey,
    label: 'Service Accounts',
    variant: 'primary',
    onClick() {
      history.push('/admin/service-accounts/aws')
    },
    _meta: {
      itemActiveRoutes: '/admin/service-accounts/aws'
    }
  },
  // {
  //   icon: faGearComplexCode,
  //   label: 'Workloads',
  //   variant: 'primary',
  //   onClick() {
  //     history.push('/admin/workloads')
  //   },
  //   _meta: {
  //     itemActiveRoutes: '/admin/workloads'
  //   }
  // },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>person</span>,
    label: 'Users',
    variant: 'primary',
    onClick() {
      history.push('/admin/users')
    },
    _meta: {
      itemActiveRoutes: '/admin/users'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>groups</span>,
    label: 'Groups',
    variant: 'primary',
    onClick() {
      history.push('/admin/groups')
    },
    _meta: {
      itemActiveRoutes: '/admin/groups'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>devices</span>,
    label: 'devices',
    variant: 'primary',
    onClick() {
      history.push('/admin/devices/approved')
    },
    _meta: {
      itemActiveRoutes: '/admin/devices'
    }
  },

  {
    itemType: 'section',
    label: 'cloud'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>cloud</span>,
    label: 'clouds',
    variant: 'primary',
    onClick() {
      history.push('/admin/clouds')
    },
    _meta: {
      itemActiveRoutes: '/admin/clouds'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>network_node</span>,
    label: 'gateways',
    variant: 'primary',
    onClick() {
      history.push('/admin/gateways')
    },
    _meta: {
      itemActiveRoutes: '/admin/gateways'
    }
  },

  // {
  //   itemType: 'section',
  //   label: 'Identity analytics'
  // },
  // {
  //   icon: faAnalytics,
  //   label: 'analytics dashboard',
  //   variant: 'primary',
  //   onClick() {
  //     history.push('/admin/idaanalyzer')
  //   },
  //   _meta: {
  //     itemActiveRoutes: '/admin/idaanalyzer'
  //   }
  // },
  {
    itemType: 'section',
    label: 'Access Management'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>stacks</span>,
    label: 'Targets',
    variant: 'primary',
    onClick() {
      history.push('/admin/targets')
    },
    _meta: {
      itemActiveRoutes: '/admin/targets'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>domain_verification</span>,
    label: 'Resources',
    variant: 'primary',
    onClick() {
      history.push('/admin/resources')
    },
    _meta: {
      itemActiveRoutes: '/admin/resources'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>apps</span>,
    label: 'applications',
    variant: 'primary',
    onClick() {
      history.push('/admin/applications')
    },
    _meta: {
      itemActiveRoutes: '/admin/applications'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>engineering</span>,
    label: 'IAM Roles',
    variant: 'primary',
    onClick() {
      history.push('/admin/iam-roles/aws')
    },
    _meta: {
      itemActiveRoutes: '/admin/iam-roles'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>psychology_alt</span>,
    label: 'Access Requests',
    variant: 'primary',
    onClick() {
      history.push('/admin/access-requests')
    },
    _meta: {
      itemActiveRoutes: '/admin/access-requests'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>assignment_turned_in</span>,
    label: 'Policies',
    variant: 'primary',
    onClick() {
      history.push('/admin/policys')
    },
    _meta: {
      itemActiveRoutes: '/admin/policys'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>deployed_code</span>,
    label: 'Bundles',
    variant: 'primary',
    onClick() {
      history.push('/admin/bundles')
    },
    _meta: {
      itemActiveRoutes: '/admin/bundles'
    }
  },
  {
    itemType: 'section',
    label: 'Activity'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>vital_signs</span>,
    label: 'activity logs',
    variant: 'primary',
    onClick() {
      history.push('/admin/activity-logs')
    },
    _meta: {
      itemActiveRoutes: '/admin/activity-logs'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>show_chart</span>,
    label: 'Session Logs',
    variant: 'primary',
    onClick() {
      history.push('/admin/session-logs')
    },
    _meta: {
      itemActiveRoutes: '/admin/session-logs'
    }
  },
  {
    itemType: 'section',
    label: 'Connections'
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>plug_connect</span>,
    label: 'integrations',
    variant: 'primary',
    onClick() {
      history.push('/admin/integrations')
    },
    _meta: {
      itemActiveRoutes: '/admin/integrations'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>lan</span>,
    label: 'RDP User Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/addomaincontrollers')
    },
    _meta: {
      itemActiveRoutes: '/admin/addomaincontrollers'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>dns</span>,
    label: 'Server Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/server-controllers')
    },
    _meta: {
      itemActiveRoutes: '/admin/server-controllers'
    }
  },
  {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>device_hub</span>,
    label: 'Proxy Management',
    variant: 'primary',
    onClick() {
      history.push('/admin/proxy-controllers')
    },
    _meta: {
      itemActiveRoutes: '/admin/proxy-controllers'
    }
  }
]
